import { LicenseType, System, SystemDetails } from "@ews/react-data";
import { useL10n } from "@ews/react-localization-context";
import { IonCol, IonGrid, IonItem, IonLabel, IonList, IonRow } from "@ionic/react";
import React from "react";
import { useHasLicense } from "../HasLicense";
import { useIsMobile } from "../Responsive";
import style from './SystemDetails.module.scss';

type DetailsProps = {
    system: System,
    details: SystemDetails;
};

const Details: React.FC<DetailsProps> = ({ system, details }) =>
{
    const { translate: t } = useL10n();
    const mobileView = useIsMobile();

    return (
        <IonGrid>
            <IonRow>
                <IonCol hidden={!details.exposeGPS} size="12" sizeMd="6" class="ion-text-center ion -padding">
                    <img style={{ maxHeight: "400px" }} alt={t("COM_FACPMANAGEMENT_FACP_DOCUMENTATION_GPS_IMAGE")} src={details.GPSSnapshotURL} />

                    {useHasLicense(LicenseType.DETAIL_VIEW) ?

                        <></>
                        : null}
                </IonCol>
                <IonCol size="12" sizeMd="6" class={style["overview-main-container"]} >
                    <IonList data-testid="list" lines={mobileView ? "full" : 'inset'} className={mobileView ? style['ion-item-mobile'] : ''}>

                        <IonItem lines="full" className={`${style.overflow}`}>

                            <IonItem lines='none' slot="start" className={`${style.firstColum} ${style.overflow}`}>
                                <IonLabel >{`${t('[SID_MNU_TAB_INFO_SCR]')}:`}</IonLabel>
                            </IonItem>

                            <IonItem lines='none' className={`${style.overflow}`}>
                                <IonLabel className={style.value}>{system?.name || ''}</IonLabel>
                            </IonItem>
                        </IonItem>

                        <IonItem lines="full" className={`${style.overflow}`}>
                            <span slot="start" className={`${style.firstColum} ${style.overflow}`}>
                                <IonItem lines='none' >
                                    <IonLabel >{`${t('COM_FACPMANAGEMENT_FACP_FIELD_FACP_ALIAS_LABEL')}:`}</IonLabel>
                                </IonItem>
                            </span>
                            <IonItem lines='none' className={`${style.overflow}`}>
                                <IonLabel className={style.value}>{system?.alias || ''}</IonLabel>
                            </IonItem>
                        </IonItem>



                        <IonItem lines="full" className={`${style.overflow}`}>
                            <span slot="start" className={`${style.firstColum} ${style.overflow}`}>
                                <IonItem lines='none' >
                                    <IonLabel >{`${t('COM_FACPMANAGEMENT_LOGS_MAIL_ANLAGENID')}:`}</IonLabel>
                                </IonItem>
                            </span>
                            <IonItem lines='none' className={`${style.overflow}`}>
                                <IonLabel className={style.value}>{system.systemNumber || ''}</IonLabel>
                            </IonItem>
                        </IonItem>

                        <IonItem lines="full" className={`${style.overflow}`}>
                            <IonItem lines='none' slot="start" className={`${style.firstColum} ${style.overflow}`}>
                                <IonLabel>{`${t('COM_FACPMANAGEMENT_FACP_FIELD_TYPE_LABEL')}:`}</IonLabel>
                            </IonItem>
                            <IonItem lines="none" className={`${style.overflow}`}>
                                <IonLabel className={style.value}>{system?.systemType}</IonLabel>
                            </IonItem>
                        </IonItem>

                        <IonItem lines="full" className={`${style.overflow}`}>
                            <IonItem lines='none' slot="start" className={`${style.firstColum} ${style.overflow}`}>
                                <IonLabel>{`${t('[SID_SYSTEM_KEY]')}:`}</IonLabel>
                            </IonItem>
                            <IonItem lines="none" className={`${style.overflow}`}>
                                <IonLabel className={style.value}>{system?.systemKey || ''}</IonLabel>
                            </IonItem>
                        </IonItem>

                        <IonItem lines="full" className={`${style.overflow}`}>
                            <IonItem lines='none' slot="start" className={`${style.firstColum} ${style.overflow}`}>
                                <IonLabel>{`${t('COM_FACPMANAGEMENT_FACP_FIELD_FACP_LOCATION1_LABEL')}:`}</IonLabel>
                            </IonItem>
                            <IonItem lines="none" className={`${style.overflow}`}>
                                <IonLabel className={style.value}>{details.location || ''}</IonLabel>
                            </IonItem>
                        </IonItem>

                        <IonItem lines="full" className={`${style.overflow}`}>
                            <IonItem lines='none' slot="start" className={`${style.firstColum} ${style.overflow}`}>
                                <IonLabel>{`${t('COM_FACPMANAGEMENT_FACP_FIELD_FACP_LOCATION2_LABEL')}:`}</IonLabel>
                            </IonItem>
                            <IonItem lines="none" className={`${style.overflow}`}>
                                <IonLabel className={style.value}>{details.site || ''}</IonLabel>
                            </IonItem>
                        </IonItem>

                        <IonItem lines="full" className={`${style.overflow}`}>
                            <IonItem lines='none' slot="start" className={`${style.firstColum} ${style.overflow}`}>
                                <IonLabel>{`${t('COM_FACPMANAGEMENT_FACP_FIELD_FACP_ADDRESS1_LABEL')}:`}</IonLabel>
                            </IonItem>
                            <IonItem lines="none" className={`${style.overflow}`}>
                                <IonLabel className={style.value}>{details.street || ''}</IonLabel>
                            </IonItem>
                        </IonItem>

                        <IonItem lines="full" className={`${style.overflow}`}>
                            <IonItem lines='none' slot="start" className={`${style.firstColum} ${style.overflow}`}>
                                <IonLabel>{`${t('COM_FACPMANAGEMENT_FACP_FIELD_FACP_ADDRESS2_LABEL')}:`}</IonLabel>
                            </IonItem>
                            <IonItem lines="none" className={`${style.overflow}`}>
                                <IonLabel className={style.value}>{details.street2 || ''}</IonLabel>
                            </IonItem>
                        </IonItem>

                        <IonItem lines="full" className={`${style.overflow}`}>
                            <IonItem lines='none' slot="start" className={`${style.firstColum} ${style.overflow}`}>
                                <IonLabel>{`${t('COM_FACPMANAGEMENT_CUSTOMERS_POSTAL_CODE')}:`}</IonLabel>
                            </IonItem>
                            <IonItem lines="none" className={`${style.overflow}`}>
                                <IonLabel className={style.value}>{details.zip || ''}</IonLabel>
                            </IonItem>
                        </IonItem>

                        <IonItem lines="full" className={`${style.overflow}`}>
                            <IonItem lines='none' slot="start" className={`${style.firstColum} ${style.overflow}`}>
                                <IonLabel>{`${t('PLG_USER_PROFILE_FIELD_CITY_LABEL')}:`}</IonLabel>
                            </IonItem>
                            <IonItem lines="none" className={`${style.overflow}`}>
                                <IonLabel className={style.value}>{details.city || ''}</IonLabel>
                            </IonItem>
                        </IonItem>

                        <IonItem lines="full" className={`${style.overflow}`}>
                            <IonItem lines='none' slot="start" className={`${style.firstColum} ${style.overflow}`}>
                                <IonLabel>{`${t('PLG_USER_PROFILE_FIELD_COUNTRY_LABEL')}:`}</IonLabel>
                            </IonItem>
                            <IonItem lines="none" className={`${style.overflow}`}>
                                <IonLabel className={style.value}>{details.country || ''}</IonLabel>
                            </IonItem>
                        </IonItem>

                    </IonList>
                </IonCol>

            </IonRow>
        </IonGrid >
    );
};

export default Details;
